
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 22 25","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M18.125 24.167h-3.02v-1.51h-3.022v1.51h-3.02v-1.51H6.041v1.51H3.02v-1.51h-.378A2.651 2.651 0 010 20.012v-6.419h3.02v6.042h15.105v-6.042h3.02v6.42a2.651 2.651 0 01-2.643 2.642h-.377v1.51zM3.02 0h3.022v1.51h3.02V0h3.021v1.51h3.021V0h3.02v1.51h.378a2.651 2.651 0 012.644 2.644v6.419h-3.021V4.53H3.02v6.042H0v-6.42A2.651 2.651 0 012.643 1.51h.378V0z"}}),_c('path',{attrs:{"d":"M7.551 6.042h6.042a1.511 1.511 0 010 3.02H9.062v1.511h4.531a1.511 1.511 0 010 3.021H9.062v3.02a1.51 1.51 0 01-3.021 0V7.553c0-.833.677-1.51 1.51-1.51z"}})])
          )
        }
      }
    